import React, { useState } from 'react';
import BannerModal from '@/components/Banner/BannerModal';
import { useUserBanners } from '@/hooks/useUserBanners';
import { useAuthStore, useOnboardingStore } from '@/store';

function BannerModalOverlay() {
  const { getBannersForPlacement, markSeen, markClicked, dismiss } = useUserBanners();
  const token = useAuthStore(state => state.token);
  const onboardingActive = useOnboardingStore(state => state.isActive);
  const [dismissed, setDismissed] = useState(new Set());

  // getBannersForPlacement already respects the 'modal' cooldown
  const modalBanners = getBannersForPlacement('modal');

  const activeBanner = modalBanners.find(b => !dismissed.has(b.id));

  const handleDismiss = (bannerId) => {
    setDismissed(prev => new Set(prev).add(bannerId));
    dismiss(bannerId);
  };

  if (!token || !activeBanner) return null;
  if (onboardingActive) return null;

  return (
    <BannerModal
      key={activeBanner.id}
      banner={activeBanner}
      onMarkSeen={markSeen}
      onCtaClick={markClicked}
      onDismiss={handleDismiss}
    />
  );
}

export default React.memo(BannerModalOverlay);
